<template>
  <div id="app">
    <router-view></router-view>
    <div class="footer" v-show="!$route.meta.notShowFooter">
      <!-- <div style="margin-right:10px;">香洲企业服务热线 0756-8889899</div>
      <div>粤ICP备2020105501号-1</div> -->
      <div style="margin-right: 10px">荷塘查策网</div>
      <div>湘ICP备2023013557号</div>
    </div>
    <el-backtop>
      <div class="icon_box"></div>
      <div class="goTopText">返回顶部</div>
    </el-backtop>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // 根据不同路由跳转不同页面
    if (this._isMobile()) {
      console.log("手机端");
      location.href = "http://www.heqitong.cn/";
    } else {
      console.log("pc端");
      // this.$router.replace("/pc_index");
    }
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  color: #2c3e50;

  ::v-deep .el-backtop {
    width: 60px;
    height: 60px;
    border-radius: 0;
    background: #fff;
    color: #2e2e2e;
    font-size: 12px;
    flex-direction: column;
    right: 10px !important;
  }
  ::v-deep .el-backtop:hover {
    background-color: #409eff;
    color: #fff;
    .icon_box {
      background-image: url("../static/zhiding_hover.png");
    }
  }
}

.footer {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3f4040;
  color: #fff;
  margin-top: auto;
  margin-bottom: 0;
}

.totop {
  width: 60px;
  height: 60px;
}

.icon_box {
  background-image: url("../static/zhiding.png");
  width: 30px;
  height: 30px;
  background-position: center center;
  background-repeat: no-repeat;
}
.goTopText {
  font-size: 12px;
}
</style>
